import { render, staticRenderFns } from "./ScopeMenuBar.vue?vue&type=template&id=4f991d78&scoped=true"
import script from "./ScopeMenuBar.vue?vue&type=script&lang=js"
export * from "./ScopeMenuBar.vue?vue&type=script&lang=js"
import style0 from "./ScopeMenuBar.vue?vue&type=style&index=0&id=4f991d78&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f991d78",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f991d78')) {
      api.createRecord('4f991d78', component.options)
    } else {
      api.reload('4f991d78', component.options)
    }
    module.hot.accept("./ScopeMenuBar.vue?vue&type=template&id=4f991d78&scoped=true", function () {
      api.rerender('4f991d78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealScope/ScopeMenuBar.vue"
export default component.exports